// extracted by mini-css-extract-plugin
module.exports = {"nav":"Paginado_nav__PqnLw","btn":"Paginado_btn__yBVo4"};